import { render, staticRenderFns } from "./Results2.vue?vue&type=template&id=40adc532"
import script from "./Results2.vue?vue&type=script&lang=js"
export * from "./Results2.vue?vue&type=script&lang=js"
import style0 from "./Results2.vue?vue&type=style&index=0&id=40adc532&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports